import { render } from "./ProjectRecordings.vue?vue&type=template&id=b439c33c&scoped=true"
import script from "./ProjectRecordings.vue?vue&type=script&lang=js"
export * from "./ProjectRecordings.vue?vue&type=script&lang=js"

import "./ProjectRecordings.vue?vue&type=style&index=0&id=b439c33c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b439c33c"]])

export default __exports__